import axios from 'axios';
import { toReportEndDate, toReportStartDate } from 'utils/reportSalesUtils';

const getSessionToken = () => {
  const sessionData = localStorage.getItem('session');
  return sessionData ? JSON.parse(sessionData).sessionInfo?.token : null;
};

export const downloadReportSales = async (startDate: string, endDate: string) => {
  const token = getSessionToken();
  const params = new URLSearchParams({
    startDate: toReportStartDate(startDate),
    endDate: toReportEndDate(endDate),
  });

  const response = await axios.get(
    `${process.env.REACT_APP_BACKEND_URL}/report-sales/export.xlsx?${params.toString()}`,
    {
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
      responseType: 'blob',
    }
  );

  const blob = response.data;
  const url = window.URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = `reporte-ventas-${startDate}_${endDate}.xlsx`;
  anchor.style.display = 'none';
  document.body.appendChild(anchor);
  anchor.click();

  setTimeout(() => {
    anchor.remove();
    window.URL.revokeObjectURL(url);
  }, 100);
};
